const jbevents =  {
  "type": "FeatureCollection",
  "name": "jetsetter_ultimate_90_day_2025",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Ultima Courchevel Belvédère",
        "address": "Quartier de Bellecôte, Courchevel 1850, France",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Ultima_Courchevel_Belvedere_rating.png?v=1743125329",
        "city": "Courchevel",
        "country": "France",
        "city_id": "cou",
        "category": "Resort Hotels",
        "sub-category": "Elevated Escapes",
        "hotel_description": "Exclusive alpine retreat with ski-in/ski-out access and pet-friendly ultra-luxury chalets.",
        "caption": "Alpine luxury meets cozy chalet life",
        "date": "2025-01-15",
        "day_number": 15,
        "source": "Ultima Courchevel Official Website",
        "website": "https://www.ultimacollection.com/en/ultima-courchevel",
        "month": "Winter",
        "product_link": "https://jbthejetsetter.com/products/apres-ski-in-courchevel",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/courchevel.gif?v=1744093051",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/three_paws.png?v=1743916520",
        "collection_name": "Celebration",
        "type": ["Elevated Escapes", "threep", "Resort"],
        "tags": ["beds", "gifts", "bigdogs", "staff", "onsite", "dining", "fees", "threep"], 
        "pet_fees": "Expensive; extra fees (€50–€100 per night)",
        "price_level": "$$$$",
        
        "pet_beds_and_bowls_score": 3,
        "pet_beds_and_bowls_notes": "Available but limited in some chalets",
        
        "welcome_gifts_and_treats_score": 3,
        "welcome_gifts_and_treats_notes": "Some treats and amenities upon arrival",
        
        "onsite_relief_areas_score": 4,
        "onsite_relief_areas_notes": "Easy access to outdoor snowy areas",
        
        "pet_friendly_dining_score": 4,
        "pet_friendly_dining_notes": "Dogs allowed in private dining spaces",
        
        "big_dogs_welcome_score": 4,
        "big_dogs_welcome_notes": "No weight limits; big dogs welcome",
        
        "staff_friendliness_score": 3,
        "staff_friendliness_notes": "Staff are accommodating but may vary seasonally",
        
        "extra_fees_score": 2,
        "extra_fees_notes": "Expensive; extra fees (€50–€100 per night)",
            "pet_fees_category": "€€€",

        "overall_score": 3.29
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          6.6344,
          45.4153
        ]
      }
    },
        {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Badrutt's Palace Hotel",
        "address": "Via Serlas 27, 7500 St. Moritz, Switzerland",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Badrutts_Palace_Hotel_rating.png?v=1743124565",
        "city": "St. Moritz",
        "country": "Switzerland",
        "city_id": "smo",
        "category": "Grand Hotel",
        "sub-category": "Elevated Escapes",
        "hotel_description": "Iconic luxury hotel offering glamorous alpine stays with world-class pet-friendly service.",
        "caption": "Timeless glamour in the Swiss Alps",
        "date": "2025-01-20",
        "day_number": 20,
        "source": "Badrutt's Palace Official Website",
        "website": "https://badruttspalace.com/",
        "month": "Winter",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/stm2.gif?v=1744933501",
              "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fourpaws.png?v=1743913215",
              "product_link": "https://www.jbthejetsetter.com/products/alpine-escape-in-st-moritz",
        "collection_name": "Celebration",
        "type": [
          "Elevated Escapes",
          "fourpaws",
          "Grand", "jbsfav1"
        ],
        "tags": [
          "beds",
          "gifts",
          "onsite",
          "dining",
          "bigdogs",
          "staff",
          "fees",
          "fourpaws", "jbsfav1"
        ],
        "pet_fees": "Expensive; extra fees (CHF 50–CHF 80 per night)",
        "price_level": "€€€",
        
        "pet_beds_and_bowls_score": 4,
        "pet_beds_and_bowls_notes": "Plush pet beds and bowls provided in rooms",

        "welcome_gifts_and_treats_score": 4,
        "welcome_gifts_and_treats_notes": "Chic welcome gifts and gourmet treats",

        "onsite_relief_areas_score": 4,
        "onsite_relief_areas_notes": "Private outdoor spaces and garden relief area",

        "pet_friendly_dining_score": 4,
        "pet_friendly_dining_notes": "Dogs allowed in select fine-dining areas",

        "big_dogs_welcome_score": 4,
        "big_dogs_welcome_notes": "No weight restrictions; very big-dog friendly",

        "staff_friendliness_score": 4,
        "staff_friendliness_notes": "Ultra-attentive and welcoming staff",

        "extra_fees_score": 2,
        "extra_fees_notes": "Expensive; extra fees (CHF 50–CHF 80 per night)",
            "pet_fees_category": "₣₣₣",
        "overall_score": 3.86
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          9.83844,
          46.497059
        ]
      }
    },

        {
      "type": "Feature",
      "properties": {
        "star": "5 Star Resort",
        "name": "Amangiri",
        "address": "1 Kayenta Road, Canyon Point, Utah, USA",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/aman_rating.png?v=1743137987",
        "city": "Canyon Point",
        "country": "USA",
        "city_id": "canyonpoint",
        "category": "Resort Hotel",
        "sub-category": "Elevated Escapes",
        "hotel_description": "A secluded desert oasis where rugged landscapes meet minimalist luxury. Experience tranquility, spa sanctuaries, and pet‑friendly adventures.",
        "caption": "Desert dreams in ultimate luxury",
        "date": "2025-01-20",
        "day_number": 20,
        "source": "Amangiri Official Website",
        "website": "https://www.aman.com/resorts/amangiri",
        "month": "Winter",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/utah.gif?v=1743754926",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fourpaws.png?v=1743913215",
        "product_link": "https://jbthejetsetter.com/products/cruisin-through-canyon-dreams-in-utah",
        "collection_name": "Celebration",
        "type": ["Elevated Escapes", "fourpaws", "Resort","jbsfav1"],
        "tags": ["beds", "gifts", "bigdogs", "staff", "onsite", "dining", "fees", "fourpaws", "jbsfav1"],
        "pet_fees": "Expensive; extra fees ($150–$200 per night)",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 4,
        "onsite_relief_areas_score": 3,
        "pet_friendly_dining_score": 3,
        "big_dogs_welcome_score": 4,
        "staff_friendliness_score": 4,
        "extra_fees_score": 1,
        "pet_beds_and_bowls_notes": "Luxurious pet beds provided in-suite.",
        "welcome_gifts_and_treats_notes": "Welcome treats and customized gifts at check-in.",
        "onsite_relief_areas_notes": "Limited desert relief areas available.",
        "pet_friendly_dining_notes": "Limited—pets can dine on private terraces only.",
        "big_dogs_welcome_notes": "Big dogs warmly welcomed with no size limit.",
        "staff_friendliness_notes": "Staff are exceptionally accommodating and pet-aware.",
        "extra_fees_notes": "High extra pet fee range ($150–$200 per night).",
            "pet_fees_category": "$$$$",
        "overall_score": 3.71
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -111.6111,
          37.0275
        ]
      }
    },

    {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Fairmont Le Château Frontenac",
        "address": "1 Rue des Carrières, Quebec City, Canada",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/frontenac_rating.png",
        "city": "Quebec City",
        "country": "Canada",
        "city_id": "qbc",
        "category": "Grand Hotel",
        "sub-category": "Scenic Stays",
        "hotel_description": "A majestic, castle-like hotel overlooking Old Quebec, blending timeless elegance with pet-friendly hospitality.",
        "caption": "Historic charm meets pet-friendly luxury",
        "date": "2025-02-03",
        "day_number": 34,
        "source": "Fairmont Official Website",
        "website": "https://www.fairmont.com/frontenac-quebec/",
        "month": "Winter",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/quebec.gif?v=1744925521",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/three_paws.png?v=1743916520",
                "product_link": "https://jbthejetsetter.com/products/day-6-winters-charm-in-quebec",
        "collection_name": "Celebration",
        "type": ["Scenic Stays", "threep", "Grand"],
        "tags": ["beds", "gifts", "bigdogs", "staff", "onsite", "dining", "fees", "threep"],
        "pet_fees": "Expensive; extra fees (CAD 50 per night)",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 3,
        "onsite_relief_areas_score": 3,
        "pet_friendly_dining_score": 3,
        "big_dogs_welcome_score": 3,
        "staff_friendliness_score": 3,
        "extra_fees_score": 2,
        "pet_beds_and_bowls_notes": "Comfortable pet beds available upon request.",
        "welcome_gifts_and_treats_notes": "Small welcome treats provided.",
        "onsite_relief_areas_notes": "Relief areas available nearby but not onsite.",
        "pet_friendly_dining_notes": "Limited pet-friendly dining options on patio.",
        "big_dogs_welcome_notes": "Big dogs allowed with prior notice.",
        "staff_friendliness_notes": "Staff is friendly but can be busy during peak times.",
        "extra_fees_notes": "Additional CAD 50 per night for pets.",
            "pet_fees_category": "$$$",
        "overall_score": 3.14
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          -71.207981,
          46.813878
        ]
      }
    },

        {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Four Seasons Resort Dubai at Jumeirah Beach",
        "address": "Jumeirah Beach Road, Dubai, UAE",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fourseasons_jumeirah_rating.png",
        "city": "Dubai",
        "country": "United Arab Emirates",
        "city_id": "dxb",
        "category": "Resort Hotel",
        "sub-category": "Waterfront Retreats",
        "hotel_description": "A serene beachfront escape where luxury meets the sea, offering premium pet-friendly accommodations.",
        "caption": "Seaside luxury with your best friend",
        "date": "2025-01-20",
        "day_number": 20,
        "source": "Four Seasons Official Website",
        "website": "https://www.fourseasons.com/dubaijb/",
        "month": "Winter",
         "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/dubai.gif?v=1744926692",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fourp.png?v=1743973103",
                "product_link": "https://jbthejetsetter.com/products/day-4-boat-life-in-dubai",
        "collection_name": "Sun & Sand",
        "type": ["Waterfront Retreats", "fourpaws", "Resort"],
        "tags": ["beds", "gifts", "bigdogs", "staff", "onsite", "dining", "fees", "fourpaws"],
        "pet_fees": "Complimentary; no additional pet fees",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 4,
        "onsite_relief_areas_score": 3,
        "pet_friendly_dining_score": 4,
        "big_dogs_welcome_score": 4,
        "staff_friendliness_score": 4,
        "extra_fees_score": 4,
        "pet_beds_and_bowls_notes": "Luxury pet beds and bowls provided.",
        "welcome_gifts_and_treats_notes": "Thoughtful pet welcome amenities.",
        "onsite_relief_areas_notes": "Outdoor areas available but no official onsite relief zone.",
        "pet_friendly_dining_notes": "Pets allowed in designated outdoor dining areas.",
        "big_dogs_welcome_notes": "Big dogs warmly welcomed with no size restriction.",
        "staff_friendliness_notes": "Staff attentive and extremely pet-friendly.",
        "extra_fees_notes": "No additional pet fees.",
            "pet_fees_category": "No Fee",
        "overall_score": 3.86
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.296249,
          25.276987
        ]
      }
    },


        {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Mövenpick Resort Petra",
        "address": "Tourism Street, Petra, Jordan",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/movenpick_petra_rating.png",
        "city": "Petra",
        "country": "Jordan",
        "city_id": "pet",
        "category": "Resort Hotel",
        "sub-category": "Scenic Stays",
        "hotel_description": "Located at the entrance to the ancient city of Petra, this resort offers pet-friendly stays infused with Middle Eastern charm.",
        "caption": "Gateway to Petra adventures",
        "date": "2025-03-10",
        "day_number": 55,
        "source": "Mövenpick Official Website",
        "website": "https://www.movenpick.com/en/middle-east/jordan/petra/resort-petra/overview/",
        "month": "Spring",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/mov.gif?v=1744933074",
        "product_link": "https://jbthejetsetter.com/products/day-3-candlelit-treasury-at-petra",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/three_paws.png?v=1743916520",
        "collection_name": "Wonders of the World",
        "type": ["Scenic Stays", "threep", "Resort"],
        "tags": ["beds", "gifts", "bigdogs", "staff", "onsite", "dining", "fees", "threep"],
        "pet_fees": "Moderate; JOD 30–50 per night",
        "pet_beds_and_bowls_score": 3,
        "welcome_gifts_and_treats_score": 2,
        "onsite_relief_areas_score": 2,
        "pet_friendly_dining_score": 2,
        "big_dogs_welcome_score": 3,
        "staff_friendliness_score": 4,
        "extra_fees_score": 3,
        "pet_beds_and_bowls_notes": "Standard pet amenities available upon request.",
        "welcome_gifts_and_treats_notes": "No special pet welcome gifts.",
        "onsite_relief_areas_notes": "Limited green areas nearby.",
        "pet_friendly_dining_notes": "Pets not allowed in main dining areas.",
        "big_dogs_welcome_notes": "Big dogs are allowed but some restrictions may apply.",
        "staff_friendliness_notes": "Very accommodating and friendly toward pets.",
        "extra_fees_notes": "Moderate pet fee charged per night.",
            "pet_fees_category": "JDx2",
        "overall_score": 2.71
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
         35.444362,
          30.326234
        ]
      }
    },

    {
  "type": "Feature",
  "properties": {
    "star": "5 Star Hotel",
    "name": "One&Only Cape Town",
    "address": "Dock Rd, V&A Waterfront, Cape Town, South Africa",
    "rating_img": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/oneonly_rating.png?v=1743916520",
    "city": "Cape Town",
    "country": "South Africa",
    "city_id": "cap",
    "category": "Resort Hotel",
    "sub-category": "Waterfront Retreats",
    "hotel_description": "A luxurious waterfront escape where Table Mountain views, serene marina vibes, and pet-friendly pampering redefine Cape Town luxury.",
    "caption": "Waterfront luxury meets mountain majesty",
    "best_time_to_go": "January 15",
    "season": "Summer",
    "source": "One&Only Official Website",
    "website": "https://www.oneandonlyresorts.com/cape-town",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capetown.gif?v=1743915545",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fourp.png?v=1743973103",
                "product_link": "https://jbthejetsetter.com/products/week-1-cape-town-the-atlantic-jewel",
    "collection_name": "World Tour",
    "type": ["Waterfront Retreats", "threep", "Resort"],
    "tags": ["beds", "gifts", "bigdogs", "staff", "onsite", "dining", "fees", "threep"],
    "price_tier": "$$$",
    "pet_fees": "Moderate; extra fees (ZAR 500 per stay)",
    
    "pet_beds_and_bowls_score": 4,
    "pet_beds_and_bowls_notes": "Plush beds and designer bowls provided.",
    
    "welcome_gifts_and_treats_score": 4,
    "welcome_gifts_and_treats_notes": "Welcome treats and personalized gifts for pets.",
    
    "onsite_relief_areas_score": 3,
    "onsite_relief_areas_notes": "Limited grassy spaces available in marina area.",
    
    "pet_friendly_dining_score": 3,
    "pet_friendly_dining_notes": "Outdoor patio dining with pets allowed.",

    "big_dogs_welcome_score": 4,
    "big_dogs_welcome_notes": "Big dogs warmly welcomed with no weight limit.",
    
    "staff_friendliness_score": 4,
    "staff_friendliness_notes": "Staff go out of their way to pamper pets.",
    
    "extra_fees_score": 3,
    "extra_fees_notes": "Moderate; ZAR 500 one-time fee for pets.",
        "pet_fees_category": "RR",
    
    "overall_score": 3.57
  },
  "geometry": {
    "type": "Point",
    "coordinates": [18.4233, -33.9072]
  }
},
        {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Four Seasons Hotel San Francisco at Embarcadero",
        "address": "222 Sansome St, San Francisco, CA 94104, United States",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/FS_Embarcadero_rating.png?v=1743920000",
        "city": "San Francisco",
        "country": "USA",
        "city_id": "sfo",
        "category": "Boutique",
        "sub-category": "City Stay",
        "hotel_description": "A luxurious high-rise sanctuary in downtown San Francisco that warmly welcomes pets.",
        "caption": "Sky-high luxury meets pet-friendly comfort",
        "date": "2025-01-15",
        "day_number": 5,
        "season": "Winter",
        "website": "https://www.fourseasons.com/sanfrancisco/embarcadero/",
        "source": "Four Seasons Official Website",
         "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/sf2.gif?v=1744930526",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png?v=1743128548",
        "product_link": "https://jbthejetsetter.com/products/golden-waves-in-the-bay", 
        "collection_name": "City Adventures",
        "type": ["City Stay", "threep", "Boutique"],
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "threep"],
        
        "pet_beds_and_bowls_score": 3,
        "pet_beds_and_bowls_notes": "Comfortable standard pet beds and bowls available.",
        
        "welcome_gifts_and_treats_score": 3,
        "welcome_gifts_and_treats_notes": "Thoughtful treats provided at check-in.",
        
        "onsite_relief_areas_score": 2,
        "onsite_relief_areas_notes": "No dedicated area, but nearby parks within walking distance.",
        
        "pet_friendly_dining_score": 2,
        "pet_friendly_dining_notes": "Limited options; some room service items are pet-appropriate.",
        
        "big_dogs_welcome_score": 3,
        "big_dogs_welcome_notes": "Big dogs accepted with prior notice.",
        
        "staff_friendliness_score": 4,
        "staff_friendliness_notes": "Staff go above and beyond for pets.",
        
        "extra_fees_score": 4,
        "extra_fees_notes": "No additional pet fees.",
        
        "overall_score": 3.0,

        "pet_fees": "No additional fees",
        "pet_fees_category": "$"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-122.40085, 37.79366]
      }
    },    
    {
  "type": "Feature",
  "properties": {
    "star": "5 Star Hotel",
    "name": "1 Hotel San Francisco",
    "address": "8 Mission St, San Francisco, CA 94105, USA",
    "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/1hotel_rating.png?v=1744123456",
    "city": "San Francisco",
    "country": "USA",
    "city_id": "sfo2",
    "category": "Boutique",
    "type": ["Scenic Stay", "fourpaws"],
    "collection_name": "Eco Chic",
    "hotel_description": "A serene escape in the heart of the city, blending luxury with nature and welcoming pets.",
    "caption": "Nature meets city luxury",
    "date": "2025-05-01",
    "day_number": 121,
    "month": "Spring",
    "source": "1 Hotel Official Website",
    "website": "https://www.1hotels.com/san-francisco",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/sf3.gif?v=1744931188",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png?v=1743128548",
        "product_link": "https://jbthejetsetter.com/products/golden-waves-in-the-bay", 
    "extra_fees": "No additional pet fees",
    "pet_fees_currency": "$",
    "price_category": "$$$",
    "pet_fees_category": "$",
    "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
    "pet_beds_and_bowls_score": 4,
    "welcome_gifts_and_treats_score": 4,
    "onsite_relief_areas_score": 3,
    "pet_friendly_dining_score": 4,
    "big_dogs_welcome_score": 4,
    "staff_friendliness_score": 4,
    "extra_fees_score": 4,
    "overall_score": 3.86,
    "pet_beds_and_bowls_notes": "Stylish eco-friendly pet beds and organic water bowls provided.",
    "welcome_gifts_and_treats_notes": "Organic treats and a welcome kit included at check-in.",
    "onsite_relief_areas_notes": "Small urban relief area available across the street.",
    "pet_friendly_dining_notes": "Dogs welcome at the outdoor garden terrace dining area.",
    "big_dogs_welcome_notes": "All dog sizes warmly welcomed without restrictions.",
    "staff_friendliness_notes": "Staff genuinely adore dogs and offer special attention.",
    "extra_fees_notes": "No additional fees for pets."
  },
  "geometry": {
    "type": "Point",
    "coordinates": [-122.3925, 37.7917]
  }
},

                  {
            "type": "Feature",
            "properties": {
                "week_num": 3,
                "date": "2025-01-17",
                "season": "Winter 25'",
                "name": "Wish List",
                "rating": "",
                "address": "The Maldives",
                "city": "The Maldives",
                "country": "",
                "category": "",
                "type": ["Waterfront Retreats"],
                "sub-category": "Waterfront Retreats",
                "month": "February",
                "collection_name": "World Tour",
                "highlight": "Overwater Villa Escape",
                "experience_description": "Wake up in an overwater villa with endless turquoise views, snorkel with manta rays, and unwind with a spa session above the ocean.",
                "caption": "Overwater villa turquoise views",
                "morning": "Start your day with a luxury breakfast and a scenic morning walk in The Maldives.",
                "midday": "Main experience: Overwater villa escape.",
                "afternoon": "Explore local culture or unwind at Cheval Blanc Randheli.",
                "evening": "Enjoy a fine dining experience and exclusive nightlife in The Maldives.",
                "website": "https://www.chevalblanc.com/en/maison/maldives/",
                "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/maldives.gif?v=1744093545",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/collection_celebration_20.png?v=1741131953",
                "product_link": "https://jbthejetsetter.com/products/day-5-overwater-villa-escape-in-the-maldives",
              "tags": [],
                "location": "The Maldives"
             
                
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    73.2207,
                    3.2028
                ]
            }
        },
            {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Borgo Egnazia",
        "address": "Strada Comunale Egnazia, Savelletri, Fasano BR, Italy",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/borgoegnazia_rating.png?v=1743125329",
        "city": "Savelletri",
        "country": "Italy",
        "city_id": "puglia",
        "category": "Resort",
        "sub-category": "Elevated Escapes",
        "hotel_description": "A dreamlike village resort in Puglia offering world-class luxury and exclusive private villas that welcome dogs with style.",
        "caption": "Village charm meets Mediterranean luxury",
        "date": "2025-05-10",
        "day_number": 17,
        "month": "Spring",
        "source": "Official Website",
        "website": "https://www.borgoegnazia.com/",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/puglia.gif?v=1743753903",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/four_paws.png?v=1743916520",
        "product_link": "https://jbthejetsetter.com/products/day-17-borgoegnazia-puglia",
        "collection_name": "Celebration",
        "type": ["Resort", "Waterfront Retreats", "fourpaws"],
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
        "pet_fees": "€30 per night",
        "pet_fees_category": "€€",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 4,
        "onsite_relief_areas_score": 3,
        "pet_friendly_dining_score": 4,
        "big_dogs_welcome_score": 4,
        "staff_friendliness_score": 4,
        "extra_fees_score": 3,
        "overall_score": 3.71,
        "pet_beds_and_bowls_notes": "Plush dog beds and bowls provided in villas.",
        "welcome_gifts_and_treats_notes": "Welcome treats and a toy for dogs.",
        "onsite_relief_areas_notes": "Private gardens in villas, limited relief areas in public spaces.",
        "pet_friendly_dining_notes": "Dogs allowed at outdoor restaurants and villa dining.",
        "big_dogs_welcome_notes": "Large dogs welcome in private villas.",
        "staff_friendliness_notes": "Warm, personalized service attentive to pets.",
        "extra_fees_notes": "Moderate nightly fee for pets."
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          17.39616,
          40.87446
        ]
      }
    },



           {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Le Bristol Paris",
        "address": "112 Rue du Faubourg Saint-Honoré, 75008 Paris, France",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/lebristolparis_rating.png",
        "city": "Paris",
        "country": "France",
        "city_id": "par",
        "category": "Grand",
        "sub-category": "City Hotels",
        "hotel_description": "The epitome of Parisian elegance, Le Bristol welcomes dogs with gourmet treats and five-star comfort.",
        "caption": "Parisian elegance with a pawfect touch",
        "date": "2025-04-10",
        "day_number": 10,
        "best_season": "Spring",
        "type": ["Grand", "fourpaws"],
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
        "pet_beds_and_bowls_score": 4,
        "pet_beds_and_bowls_notes": "Luxurious pet beds and bowls are provided in-room.",
        "welcome_gifts_and_treats_score": 4,
        "welcome_gifts_and_treats_notes": "Dogs are greeted with gourmet treats from the chef.",
        "onsite_relief_areas_score": 3,
        "onsite_relief_areas_notes": "Nearby outdoor areas are available for relief, but no onsite space.",
        "pet_friendly_dining_score": 4,
        "pet_friendly_dining_notes": "Dogs are allowed at Café Antonia and some outdoor areas.",
        "big_dogs_welcome_score": 4,
        "big_dogs_welcome_notes": "Large dogs are warmly welcomed, with a weight limit of 20kg.",
        "staff_friendliness_score": 4,
        "staff_friendliness_notes": "Staff provide tailored services for pets and owners.",
        "extra_fees_score": 3,
        "extra_fees_notes": "Pet stay costs €50 per night, considered moderate.",
        "overall_score": 3.86,
        "price_category": 4,
        "extra_fees_details": "€50 per night",
        "pet_fees_currency": "€",
        "website": "https://www.oetkercollection.com/hotels/le-bristol-paris/",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/lebristolparis1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fourpaws.png",
        "product_link": "https://jbthejetsetter.com/products/day-10-parisian-elegance-le-bristol-paris",
        "collection_name": "Celebration",
        "source": "Le Bristol Paris Official Website"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [2.3145, 48.8718]
      }
    },

    {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Rosewood London",
        "address": "252 High Holborn",
        "city": "London",
        "country": "United Kingdom",
        "city_id": "lon",
        "category": "Boutique",
        "type": ["Boutique Hotels", "Elevated Escapes", "fourpaws"],
        "hotel_description": "An opulent city retreat where pets are pampered with gourmet treats and luxury amenities.",
        "caption": "Elegant city escape with bespoke pet luxury.",
        "date": "2025-04-01",
        "day_number": 91,
        "season": "Spring",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/rosewood_london.png?v=1744043201",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jbpaw_1.png",
        "product_link": "",
        "collection_name": "Dream",
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
        "pet_fees": "£50 per night",
        "pet_fees_category": "Expensive; extra fees (£50 per night)",
        "price_category": "$$$$",
        "pet_beds_and_bowls_score": 4,
        "pet_beds_and_bowls_notes": "Luxury pet beds and bowls provided in-room.",
        "welcome_gifts_and_treats_score": 4,
        "welcome_gifts_and_treats_notes": "Welcome treats and toys curated for each pet.",
        "onsite_relief_areas_score": 3,
        "onsite_relief_areas_notes": "Small courtyard available for quick relief.",
        "pet_friendly_dining_score": 4,
        "pet_friendly_dining_notes": "Pets allowed in terrace dining areas.",
        "big_dogs_welcome_score": 4,
        "big_dogs_welcome_notes": "No weight restrictions; all dogs welcome.",
        "staff_friendliness_score": 4,
        "staff_friendliness_notes": "Staff are attentive and treat pets like royalty.",
        "extra_fees_score": 3,
        "extra_fees_notes": "£50 per pet, per night.",
        "overall_score": 3.86
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-0.1195, 51.5176]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Hôtel de Crillon, A Rosewood Hotel",
        "address": "10 Place de la Concorde",
        "city": "Paris",
        "country": "France",
        "city_id": "par",
        "category": "Boutique",
        "type": ["Boutique Hotels", "Elevated Escapes", "fourpaws"],
        "hotel_description": "One of Paris' grandest hotels offers exceptional service and luxurious amenities for pets.",
        "caption": "Historic Parisian grandeur with pet indulgence.",
        "date": "2025-04-01",
        "day_number": 91,
        "season": "Spring",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/hotel_crillon.png?v=1744043201",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jbpaw_1.png",
        "product_link": "",
        "collection_name": "Dream",
        "tags": ["beds", "gifts", "dining", "bigdogs", "staff", "fees", "fourpaws"],
        "pet_fees": "€50 per night",
        "pet_fees_category": "Expensive; extra fees (€50 per night)",
        "price_category": "$$$$",
        "pet_beds_and_bowls_score": 4,
        "pet_beds_and_bowls_notes": "Custom luxury beds and water bowls offered.",
        "welcome_gifts_and_treats_score": 4,
        "welcome_gifts_and_treats_notes": "Welcome gifts from Parisian pet boutiques.",
        "onsite_relief_areas_score": 2,
        "onsite_relief_areas_notes": "Nearby parks but no dedicated onsite area.",
        "pet_friendly_dining_score": 4,
        "pet_friendly_dining_notes": "Terrace dining options for pets.",
        "big_dogs_welcome_score": 4,
        "big_dogs_welcome_notes": "No restrictions on dog sizes.",
        "staff_friendliness_score": 4,
        "staff_friendliness_notes": "Staff warmly welcome and pamper pets.",
        "extra_fees_score": 3,
        "extra_fees_notes": "€50 per pet per night.",
        "overall_score": 3.71
      },
      "geometry": {
        "type": "Point",
        "coordinates": [2.3211, 48.8688]
      }
    },

    {
  "type": "Feature",
  "properties": {
    "star": "5 Star Hotel",
    "name": "The Lowell",
    "address": "28 East 63rd Street",
    "city": "New York City",
    "country": "USA",
    "city_id": "nyc",
    "category": "Boutique",
    "type": ["Boutique Hotels", "Elevated Escapes", "fourpaws"],
    "hotel_description": "A discreet, luxurious retreat in Manhattan, offering bespoke experiences for you and your dog.",
    "caption": "Elegant NYC hideaway for you and your pup.",
    "date": "2025-04-01",
    "day_number": 91,
    "season": "Spring",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/the_lowell.png?v=1744043201",
    "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jbpaw_1.png",
    "product_link": "",
    "collection_name": "Dream",
    "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
    "pet_fees": "$50 per night",
    "pet_fees_category": "Expensive; extra fees ($50 per night)",
    "price_category": "$$$$",
    "pet_beds_and_bowls_score": 4,
    "pet_beds_and_bowls_notes": "Luxury dog beds and bowls provided.",
    "welcome_gifts_and_treats_score": 4,
    "welcome_gifts_and_treats_notes": "Personalized welcome gifts.",
    "onsite_relief_areas_score": 3,
    "onsite_relief_areas_notes": "Nearby park access for dog walking.",
    "pet_friendly_dining_score": 4,
    "pet_friendly_dining_notes": "Dogs welcome at The Pembroke Room terrace.",
    "big_dogs_welcome_score": 4,
    "big_dogs_welcome_notes": "Large breeds accepted.",
    "staff_friendliness_score": 4,
    "staff_friendliness_notes": "Staff provide excellent personalized pet service.",
    "extra_fees_score": 3,
    "extra_fees_notes": "$50 per pet, per night.",
    "overall_score": 3.86
  },
  "geometry": {
    "type": "Point",
    "coordinates": [-73.9691, 40.7648]
  }
},
{
  "type": "Feature",
  "properties": {
    "star": "5 Star Hotel",
    "name": "Kimpton Fitzroy London",
    "address": "1-8 Russell Square",
    "city": "London",
    "country": "United Kingdom",
    "city_id": "lon",
    "category": "Boutique",
    "type": ["Boutique Hotels", "Scenic Stay", "fourpaws"],
    "hotel_description": "A vibrant, dog-welcoming landmark hotel right at Russell Square with no pet fees.",
    "caption": "Iconic London stays where dogs rule.",
    "date": "2025-04-01",
    "day_number": 91,
    "season": "Spring",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/kimpton_fitzroy.png?v=1744043201",
    "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jbpaw_1.png",
    "product_link": "",
    "collection_name": "Dream",
    "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fourpaws"],
    "pet_fees": "No extra fees",
    "pet_fees_category": "No extra pet fees",
    "price_category": "$$$",
    "pet_beds_and_bowls_score": 4,
    "pet_beds_and_bowls_notes": "Beds and bowls complimentary for pets.",
    "welcome_gifts_and_treats_score": 4,
    "welcome_gifts_and_treats_notes": "Welcome pack with treats and toys.",
    "onsite_relief_areas_score": 4,
    "onsite_relief_areas_notes": "Quick access to Russell Square park.",
    "pet_friendly_dining_score": 4,
    "pet_friendly_dining_notes": "Pets welcome in selected hotel dining areas.",
    "big_dogs_welcome_score": 4,
    "big_dogs_welcome_notes": "All dog sizes warmly accepted.",
    "staff_friendliness_score": 4,
    "staff_friendliness_notes": "Staff go out of their way to cater to pets.",
    "extra_fees_score": 4,
    "extra_fees_notes": "No pet fees charged.",
    "overall_score": 4.00
  },
  "geometry": {
    "type": "Point",
    "coordinates": [-0.1241, 51.5224]
  }
},


    {
  "type": "Feature",
  "properties": {
    "star": "5 Star Hotel",
    "name": "Rosewood Hong Kong",
    "address": "Victoria Dockside, 18 Salisbury Rd, Tsim Sha Tsui",
    "city": "Hong Kong",
    "country": "China",
    "city_id": "hk",
    "category": "Grand",
    "type": ["Grand Hotels", "Waterfront Retreats", "fourpaws"],
    "hotel_description": "The pinnacle of luxury on Victoria Harbour, where pets are spoiled as much as their owners.",
    "caption": "Waterfront grandeur with five-star pet perks.",
    "date": "2025-04-01",
    "day_number": 91,
    "season": "Spring",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/rosewood_hk.png?v=1744043201",
    "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jbpaw_1.png",
    "product_link": "",
    "collection_name": "Dream",
    "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
    "pet_fees": "$120 per stay",
    "pet_fees_category": "Expensive; extra fees ($120 per stay)",
    "price_category": "$$$$",
    "pet_beds_and_bowls_score": 4,
    "pet_beds_and_bowls_notes": "Signature Rosewood pet beds and bowls.",
    "welcome_gifts_and_treats_score": 4,
    "welcome_gifts_and_treats_notes": "Lavish welcome amenities for pets.",
    "onsite_relief_areas_score": 4,
    "onsite_relief_areas_notes": "Dedicated pet areas within hotel grounds.",
    "pet_friendly_dining_score": 4,
    "pet_friendly_dining_notes": "Pet-friendly terrace dining.",
    "big_dogs_welcome_score": 4,
    "big_dogs_welcome_notes": "Big dogs warmly embraced.",
    "staff_friendliness_score": 4,
    "staff_friendliness_notes": "Exemplary pet-focused service.",
    "extra_fees_score": 3,
    "extra_fees_notes": "$120 per stay pet fee.",
    "overall_score": 3.86
  },
  "geometry": {
    "type": "Point",
    "coordinates": [114.169361, 22.319303]
  }
},
{
  "type": "Feature",
  "properties": {
    "star": "5 Star Resort",
    "name": "1 Hotel South Beach",
    "address": "2341 Collins Ave",
    "city": "Miami",
    "country": "USA",
    "city_id": "mia",
    "category": "Resort",
    "type": ["Resort Hotels", "Waterfront Retreats", "fourpaws"],
    "hotel_description": "A beachfront eco-luxury haven where dogs are welcomed with sustainable style.",
    "caption": "Beach bliss with eco-friendly pet perks.",
    "date": "2025-04-01",
    "day_number": 91,
    "season": "Spring",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/1hotel_southbeach.png?v=1744043201",
    "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jbpaw_1.png",
    "product_link": "",
    "collection_name": "Dream",
    "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fourpaws"],
    "pet_fees": "No extra fees",
    "pet_fees_category": "No extra pet fees",
    "price_category": "$$$$",
    "pet_beds_and_bowls_score": 4,
    "pet_beds_and_bowls_notes": "Organic pet beds and eco-friendly bowls.",
    "welcome_gifts_and_treats_score": 4,
    "welcome_gifts_and_treats_notes": "Natural welcome treats for dogs.",
    "onsite_relief_areas_score": 4,
    "onsite_relief_areas_notes": "Pet-friendly garden spaces.",
    "pet_friendly_dining_score": 4,
    "pet_friendly_dining_notes": "Dog-friendly beachside dining.",
    "big_dogs_welcome_score": 4,
    "big_dogs_welcome_notes": "Large dogs are loved here.",
    "staff_friendliness_score": 4,
    "staff_friendliness_notes": "Staff genuinely adore dogs.",
    "extra_fees_score": 4,
    "extra_fees_notes": "No pet fees charged.",
    "overall_score": 4.00
  },
  "geometry": {
    "type": "Point",
    "coordinates": [-80.191788, 25.761681]
  }
},


{
  "type": "Feature",
  "properties": {
    "star": "5 Star Hotel",
    "name": "The Langham Sydney",
    "address": "89-113 Kent Street",
    "city": "Sydney",
    "country": "Australia",
    "city_id": "syd",
    "category": "Grand",
    "type": ["Grand Hotels", "Waterfront Retreats", "fourpaws"],
    "hotel_description": "Classic elegance meets pet-friendly luxury in the heart of Sydney.",
    "caption": "Timeless Sydney luxury for you and your dog.",
    "date": "2025-04-01",
    "day_number": 91,
    "season": "Spring",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/langham_sydney.png?v=1744043201",
    "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jbpaw_1.png",
    "product_link": "",
    "collection_name": "Dream",
    "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
    "pet_fees": "AUD 120 per stay",
    "pet_fees_category": "Expensive; extra fees (AUD 120 per stay)",
    "price_category": "$$$$",
    "pet_beds_and_bowls_score": 4,
    "pet_beds_and_bowls_notes": "Deluxe beds and bowls for dogs.",
    "welcome_gifts_and_treats_score": 4,
    "welcome_gifts_and_treats_notes": "Gourmet treats and amenities.",
    "onsite_relief_areas_score": 3,
    "onsite_relief_areas_notes": "Nearby green areas for dogs.",
    "pet_friendly_dining_score": 4,
    "pet_friendly_dining_notes": "Pets allowed on terrace dining.",
    "big_dogs_welcome_score": 4,
    "big_dogs_welcome_notes": "Big breeds accepted with style.",
    "staff_friendliness_score": 4,
    "staff_friendliness_notes": "Charming pet-welcoming staff.",
    "extra_fees_score": 3,
    "extra_fees_notes": "AUD 120 per pet stay fee.",
    "overall_score": 3.86
  },
  "geometry": {
    "type": "Point",
    "coordinates": [151.20929, -33.86882]
  }
},
{
  "type": "Feature",
  "properties": {
    "star": "5 Star Resort",
    "name": "Eden Rock St. Barths",
    "address": "Baie de St Jean",
    "city": "Saint Barthélemy",
    "country": "France",
    "city_id": "sbh",
    "category": "Resort",
    "type": ["Resort Hotels", "Waterfront Retreats", "fourpaws"],
    "hotel_description": "A glamorous Caribbean retreat where pets are pampered as VIPs.",
    "caption": "Island glamour with paws in paradise.",
    "date": "2025-04-01",
    "day_number": 91,
    "season": "Spring",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/edenrock_stbarths.png?v=1744043201",
    "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/jbpaw_1.png",
    "product_link": "",
    "collection_name": "Dream",
    "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
    "pet_fees": "EUR 50 per stay",
    "pet_fees_category": "Expensive; extra fees (EUR 50 per stay)",
    "price_category": "$$$$",
    "pet_beds_and_bowls_score": 4,
    "pet_beds_and_bowls_notes": "Island-style pet amenities.",
    "welcome_gifts_and_treats_score": 4,
    "welcome_gifts_and_treats_notes": "Tropical welcome gifts for pets.",
    "onsite_relief_areas_score": 3,
    "onsite_relief_areas_notes": "Beach and grounds relief areas.",
    "pet_friendly_dining_score": 4,
    "pet_friendly_dining_notes": "Outdoor dining spaces for dogs.",
    "big_dogs_welcome_score": 4,
    "big_dogs_welcome_notes": "Large dogs welcome island-style.",
    "staff_friendliness_score": 4,
    "staff_friendliness_notes": "Island hospitality extends to pets.",
    "extra_fees_score": 3,
    "extra_fees_notes": "EUR 50 pet fee per stay.",
    "overall_score": 3.86
  },
  "geometry": {
    "type": "Point",
    "coordinates": [-62.8333, 17.9]
  }
},





    
      {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Hotel Adlon Kempinski",
        "address": "Unter den Linden 77, 10117 Berlin, Germany",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/hotel_adlon_kempinski_rating.png",
        "city": "Berlin",
        "country": "Germany",
        "city_id": "ber",
        "category": "Grand",
        "sub-category": "Elevated Escapes",
        "hotel_description": "Historic grandeur with luxury pet amenities steps from Brandenburg Gate.",
        "caption": "Timeless luxury with your best friend",
        "date": "January 15",
        "day_number": 15,
        "month": "Winter",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/berlin1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/three_paws.png",
        "product_link": "https://jbthejetsetter.com/products/hotel-adlon-kempinski",
        "collection_name": "Celebration",
        "type": ["Grand", "Elevated Escapes", "threep"],
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "threep"],
        "pet_fees_details": "€50 per stay",
        "pet_fees_category": "€€€",
        "pet_fees_currency": "€",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 4,
        "onsite_relief_areas_score": 3,
        "pet_friendly_dining_score": 3,
        "big_dogs_welcome_score": 4,
        "staff_friendliness_score": 4,
        "extra_fees_score": 3,
        "overall_score": 3.71,
        "pet_beds_and_bowls_notes": "Plush beds and bowls included on request.",
        "welcome_gifts_and_treats_notes": "Charming welcome amenities for pets.",
        "onsite_relief_areas_notes": "Limited green spaces outside.",
        "pet_friendly_dining_notes": "Pets allowed at outdoor areas.",
        "big_dogs_welcome_notes": "Big dogs warmly welcomed.",
        "staff_friendliness_notes": "Staff are exceptionally accommodating to pets.",
        "extra_fees_notes": "€50 per stay."
      },
      "geometry": {
        "type": "Point",
        "coordinates": [13.404954, 52.520008]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "The Egerton House Hotel",
        "address": "17-19 Egerton Terrace, London SW3 2BX, United Kingdom",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/egerton_house_rating.png",
        "city": "London",
        "country": "United Kingdom",
        "city_id": "lon",
        "category": "Boutique",
        "sub-category": "Elevated Escapes",
        "hotel_description": "Boutique luxury with personalized pet pampering in the heart of London.",
        "caption": "A royal stay for you and your dog",
        "date": "May 10",
        "day_number": 130,
        "month": "Spring",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/london1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/four_paws.png",
        "product_link": "https://jbthejetsetter.com/products/the-egerton-house",
        "collection_name": "Celebration",
        "type": ["Boutique", "Elevated Escapes", "fourpaws"],
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "fourpaws"],
        "pet_fees_details": "No additional pet fee",
        "pet_fees_category": "£",
        "pet_fees_currency": "£",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 4,
        "onsite_relief_areas_score": 4,
        "pet_friendly_dining_score": 4,
        "big_dogs_welcome_score": 4,
        "staff_friendliness_score": 4,
        "extra_fees_score": 4,
        "overall_score": 4,
        "pet_beds_and_bowls_notes": "Luxury bedding and dishes provided.",
        "welcome_gifts_and_treats_notes": "Exclusive gifts and treats upon arrival.",
        "onsite_relief_areas_notes": "Garden relief areas nearby.",
        "pet_friendly_dining_notes": "Pets allowed for high tea.",
        "big_dogs_welcome_notes": "All sizes welcome with love.",
        "staff_friendliness_notes": "Truly pet-obsessed staff.",
        "extra_fees_notes": "No additional charge."
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-0.127758, 51.507351]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Hotel Bristol",
        "address": "Kärntner Ring 1, 1010 Wien, Austria",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/hotel_bristol_rating.png",
        "city": "Vienna",
        "country": "Austria",
        "city_id": "vien",
        "category": "Grand",
        "sub-category": "Elevated Escapes",
        "hotel_description": "Classic Viennese glamour with VIP pet treatment.",
        "caption": "Vienna’s grand hospitality for pets",
        "date": "December 1",
        "day_number": 335,
        "month": "Winter",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/vienna1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/three_paws.png",
        "product_link": "https://jbthejetsetter.com/products/hotel-bristol",
        "collection_name": "Celebration",
        "type": ["Grand", "Scenic Stay", "threep"],
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "threep"],
        "pet_fees_details": "€50 per night",
        "pet_fees_category": "€€€",
        "pet_fees_currency": "€",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 4,
        "onsite_relief_areas_score": 3,
        "pet_friendly_dining_score": 4,
        "big_dogs_welcome_score": 4,
        "staff_friendliness_score": 4,
        "extra_fees_score": 3,
        "overall_score": 3.71,
        "pet_beds_and_bowls_notes": "Luxury bedding and bowls provided.",
        "welcome_gifts_and_treats_notes": "Chic pet amenities.",
        "onsite_relief_areas_notes": "Nearby parks accessible.",
        "pet_friendly_dining_notes": "Pets allowed at terrace dining.",
        "big_dogs_welcome_notes": "No size restriction.",
        "staff_friendliness_notes": "Elegant and friendly staff.",
        "extra_fees_notes": "€50 per night."
      },
      "geometry": {
        "type": "Point",
        "coordinates": [16.373819, 48.208176]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "Pulitzer Amsterdam",
        "address": "Prinsengracht 323, 1016 GZ Amsterdam, Netherlands",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/pulitzer_amsterdam_rating.png",
        "city": "Amsterdam",
        "country": "Netherlands",
        "city_id": "ams",
        "category": "Boutique",
        "sub-category": "Scenic Stay",
        "hotel_description": "Charming canal-side boutique offering a pet-friendly stay.",
        "caption": "Dutch charm for you and your pup",
        "date": "April 15",
        "day_number": 105,
        "month": "Spring",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/amsterdam1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/three_paws.png",
        "product_link": "https://jbthejetsetter.com/products/pulitzer-amsterdam",
        "collection_name": "Celebration",
        "type": ["Boutique", "Scenic Stay", "threep"],
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "threep"],
        "pet_fees_details": "€50 per night",
        "pet_fees_category": "€€€",
        "pet_fees_currency": "€",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 4,
        "onsite_relief_areas_score": 3,
        "pet_friendly_dining_score": 3,
        "big_dogs_welcome_score": 4,
        "staff_friendliness_score": 4,
        "extra_fees_score": 3,
        "overall_score": 3.57,
        "pet_beds_and_bowls_notes": "Pet amenities ready in room.",
        "welcome_gifts_and_treats_notes": "Lovely treats at check-in.",
        "onsite_relief_areas_notes": "Public parks nearby.",
        "pet_friendly_dining_notes": "Outdoor patio pet access.",
        "big_dogs_welcome_notes": "Welcomes larger breeds.",
        "staff_friendliness_notes": "Friendly Amsterdam hospitality.",
        "extra_fees_notes": "€50 per night."
      },
      "geometry": {
        "type": "Point",
        "coordinates": [4.904138, 52.367573]
      }
    },
       {
      "type": "Feature",
      "properties": {
        "star": "5 Star Hotel",
        "name": "The Chedi Andermatt",
        "address": "Gotthardstrasse 4, 6490 Andermatt, Switzerland",
        "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/the_chedi_andermatt_rating.png",
        "city": "Andermatt",
        "country": "Switzerland",
        "city_id": "andermatt",
        "category": "Resort",
        "sub-category": "Elevated Escapes",
        "hotel_description": "Alpine serenity and luxury where dogs are pampered too.",
        "caption": "Swiss alpine bliss for you and your dog",
        "date": "January 20",
        "day_number": 20,
        "month": "Winter",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/andermatt1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/three_paws.png",
        "product_link": "https://jbthejetsetter.com/products/the-chedi-andermatt",
        "collection_name": "Celebration",
        "type": ["Resort", "Scenic Stay", "threep"],
        "tags": ["beds", "gifts", "onsite", "dining", "bigdogs", "staff", "fees", "threep"],
        "pet_fees_details": "CHF 50 per night",
        "pet_fees_category": "₣₣₣",
        "pet_fees_currency": "CHF",
        "pet_beds_and_bowls_score": 4,
        "welcome_gifts_and_treats_score": 4,
        "onsite_relief_areas_score": 3,
        "pet_friendly_dining_score": 2,
        "big_dogs_welcome_score": 4,
        "staff_friendliness_score": 4,
        "extra_fees_score": 3,
        "overall_score": 3.43,
        "pet_beds_and_bowls_notes": "High-end bedding and bowls upon request.",
        "welcome_gifts_and_treats_notes": "Elegant welcome package for pets.",
        "onsite_relief_areas_notes": "Limited winter relief areas.",
        "pet_friendly_dining_notes": "Pets allowed on terraces, not inside restaurants.",
        "big_dogs_welcome_notes": "Large breeds are accepted.",
        "staff_friendliness_notes": "Staff are warm and attentive to pets.",
        "extra_fees_notes": "CHF 50 per night."
      },
      "geometry": {
        "type": "Point",
        "coordinates": [8.5924, 46.6345]
      }
    },
          
    ]
}